export function sortCountries(
  displayedCountries: { label: string; value: string }[],
  sortConfig: { key: string; direction: 'asc' | 'desc' },
) {
  return [...displayedCountries].sort((a, b) => {
    if (sortConfig.direction === 'asc') {
      return a.label.localeCompare(b.label);
    } else {
      return b.label.localeCompare(a.label);
    }
  });
}
